var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M633.848-434.5H197.37q-19.153 0-32.327-13.174T151.869-480q0-19.152 13.174-32.326T197.37-525.5h436.478L447.174-712.174q-13.674-13.674-13.294-32.065.381-18.391 14.055-32.065 13.674-12.674 32.065-13.055 18.391-.38 32.065 13.294l264 264q6.718 6.717 9.816 14.913 3.097 8.195 3.097 17.152t-3.097 17.152q-3.098 8.196-9.816 14.913L511.826-183.696q-12.913 12.914-31.565 12.914t-32.326-12.914q-13.674-13.674-13.674-32.445 0-18.772 13.674-32.446L633.848-434.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/forwardArrow.55a853be52e907fe63ab810e43deb445.svg";
export { ForwardRef as ReactComponent };